import React from 'react';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';

const tableHead = [
  {
    headerName: 'Unit Type',
    field: 'paramTestIdVO.shortDescription',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_350,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units greater than unit threshold',
    field: 'defTestOnInd',
    filter: false,
    sortable: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    showCheckboxIcon: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    maxLength: Styles.Length_1,
    cellRenderer: 'checkboxRenderer',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Threshold number of units',
    field: 'defTestAmt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Mail Order Multiplier',
    field: 'defMailOrderMultiplier',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    resizable: false,
    cellRenderer: 'TextBoxRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export default tableHead;
